export const headers: [string, string][] = (() => {
    var headers: [string, string][] = []
    process.env.REACT_APP_USERID && headers.push(["X-EyeTowers-UserID", process.env.REACT_APP_USERID])
    process.env.REACT_APP_SESSIONID && headers.push(["X-EyeTowers-SessionID", process.env.REACT_APP_SESSIONID])
    return headers
})()
